(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/javascripts/animations.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/javascripts/animations.js');


'use strict';

const {
  isSelfService
} = svs.core.config.data.svsconfig;
function startFadeInText() {
  const elHeader = document.querySelector('.lotto-start .js-start-header');
  const elText = document.querySelector('.lotto-start .js-start-text');
  const elButton = document.querySelector('.lotto-start .js-button-wrapper');
  const elPackagesHeader = document.querySelector('.lotto-start .js-packages-header');
  const elPackages = document.querySelector('.lotto-start .js-packages-wrapper');
  const elButtons = document.querySelector('.lotto-start .js-start-buttons');
  const elements = [elHeader, elText, elButton, elPackagesHeader, elPackages, elButtons];
  if (elements.some(el => !el)) {
    return;
  }
  const tl = gsap.timeline({
    delay: isSelfService ? 0 : 0.75
  });
  tl.set(elements, {
    opacity: 0,
    y: 25
  });
  tl.to(elements, {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: 'power4.out',
    delay: 0.5,
    stagger: 0.25
  });
}
svs.numbergames.game.animations.lotto = {
  startFadeInText
};

 })(window);